export * from './events'

export const INIT_TRACKER = '@GLOBAL/TRACKER/INIT_TRACKER'
export const DETECT_IP = '@GLOBAL/TRACKER/DETECT_IP'
